module.exports = __webpack_public_path__ + "static/media/carolina-herrera-good-girl-bad-body-big.3351c753.png";